<template>
  <div v-if="Object.keys(dataForm).length">
    <el-form ref="dataForm" :model="dataForm" label-width="0" :inline-message="true" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
      <!-- 基金信息 - 基金托管服务 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="dataForm.fundInfoList && dataForm.fundInfoList.length != 0">
          <p class="messageTitle">{{ $t("enroll.upload.fundMessage") }}</p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.fundMessageTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="dataForm.fundInfoList">
              <el-table-column prop="fundName" :label="$t('enroll.questionnaire.proposedFundName')" align="center" width="300px"></el-table-column>
              <el-table-column prop="fundType" :label="$t('enroll.questionnaire.fundType')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("fundTypeList", scope.row.fundType) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <!-- 上传基金营业执照 -->
                  <div>
                    <el-form-item
                      :prop="`fundInfoList.${scope.$index}.fundBusinessLicenseUrls`"
                      :ref="`fundInfoList.${scope.$index}.fundBusinessLicenseUrls`"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.fundBusinessLicenseUrls"
                        :action="`${ossUploadUrl}/fileUpload/fundBusinessLicenseUrls/upload`"
                        :button-text="$t('enroll.upload.fundBusinessProfileUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>

                  <!-- 基金meno -->
                  <div>
                    <el-form-item
                      :prop="`fundInfoList.${scope.$index}.fundMemoUrls`"
                      :ref="`fundInfoList.${scope.$index}.fundMemoUrls`"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.fundMemoUrls"
                        :action="`${ossUploadUrl}/fileUpload/fundMemoUrls/upload`"
                        :button-text="$t('enroll.upload.fundMessageMemoUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>

                  <!-- 基金说明文件 -->
                  <div>
                    <el-form-item
                      :prop="`fundInfoList.${scope.$index}.fundInfoUrls`"
                      :ref="`fundInfoList.${scope.$index}.fundInfoUrls`"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.fundInfoUrls"
                        :action="`${ossUploadUrl}/fileUpload/fundInfoUrls/upload`"
                        :button-text="$t('enroll.upload.fundMessageIncludingUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 基金的董事|股东(个人)的护照身份证件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="individualFundMembers.length != 0">
          <p class="messageTitle">
            {{ $t("enroll.upload.fundPassport") }}
            <el-popover placement="bottom" trigger="hover">
              <div>
                <p class="lh10 fs12 preLine">
                  {{ $t("enroll.upload.certificationRequirements") }}
                </p>
              </div>
              <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
            </el-popover>
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.comprehensiveIdentityTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="individualFundMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.duty')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-form-item
                      :prop="`companyFundMemberList.${getRealIndex(scope.row, 'companyFundMemberList')}.identificationUrls`"
                      :ref="`companyFundMemberList.${getRealIndex(scope.row, 'companyFundMemberList')}.identificationUrls`"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.identificationUrls"
                        :action="`${ossUploadUrl}/fileUpload/identificationUrls/upload`"
                        :button-text="$t('enroll.upload.identityUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 基金的董事|股东的近三个月以内的地址证明原件扫描件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="allActiveFundMembers.length != 0">
          <p class="messageTitle">{{ $t("enroll.upload.fundSiteTitle") }}</p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.comprehensiveSiteTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="allActiveFundMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.duty')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyFundMemberList.${getRealIndex(scope.row, 'companyFundMemberList')}.addressIdUrls`"
                    :ref="`companyFundMemberList.${getRealIndex(scope.row, 'companyFundMemberList')}.addressIdUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.addressIdUrls"
                      :action="`${ossUploadUrl}/fileUpload/addressIdUrls/upload`"
                      :button-text="$t('enroll.upload.siteUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 基金的股东(公司)的营业执照原件扫描件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="corporateFundMembers.length != 0">
          <p class="messageTitle">
            {{ $t("enroll.upload.fundBusinessTitle") }}
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.comprehensiveBusinessTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="corporateFundMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.nameOrCompany')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.shareholderOrCompany')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyFundMemberList.${getRealIndex(scope.row, 'companyFundMemberList')}.businessLicenseUrls`"
                    :ref="`companyFundMemberList.${getRealIndex(scope.row, 'companyFundMemberList')}.businessLicenseUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.businessLicenseUrls"
                      :action="`${ossUploadUrl}/fileUpload/businessLicenseUrls/upload`"
                      :button-text="$t('enroll.upload.businessUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 基金的股权架构图 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.fundEquityStructure") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.comprehensiveStructureSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="fundsShareholdingStructureUrls"
                  ref="fundsShareholdingStructureUrls"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.fundsShareholdingStructureUrls"
                    :action="`${ossUploadUrl}/fileUpload/fundsShareholdingStructureUrls/upload`"
                    :button-text="$t('enroll.upload.equityStructureFundUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 基金管理公司的董事|股东(个人)的护照身份证件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="individualCompanyMembers.length != 0">
          <p class="messageTitle">
            {{ $t("enroll.upload.fundManagerPassport") }}
            <el-popover placement="bottom" trigger="hover">
              <div>
                <p class="lh10 fs12 preLine">
                  {{ $t("enroll.upload.certificationRequirements") }}
                </p>
              </div>
              <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
            </el-popover>
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.comprehensiveIdentityTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="individualCompanyMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.duty')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-form-item
                      :prop="`companyMemberList.${getRealIndex(scope.row, 'companyMemberList')}.identificationUrls`"
                      :ref="`companyMemberList.${getRealIndex(scope.row, 'companyMemberList')}.identificationUrls`"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.identificationUrls"
                        :action="`${ossUploadUrl}/fileUpload/identificationUrls/upload`"
                        :button-text="$t('enroll.upload.identityUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 基金管理公司的董事|股东的近三个月以内的地址证明原件扫描件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="allActiveCompanyMembers.length != 0">
          <p class="messageTitle">
            {{ $t("enroll.upload.fundManagerSiteTitle") }}
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.comprehensiveSiteTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="allActiveCompanyMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.duty')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyMemberList.${getRealIndex(scope.row, 'companyMemberList')}.addressIdUrls`"
                    :ref="`companyMemberList.${getRealIndex(scope.row, 'companyMemberList')}.addressIdUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.addressIdUrls"
                      :action="`${ossUploadUrl}/fileUpload/addressIdUrls/upload`"
                      :button-text="$t('enroll.upload.siteUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 基金管理公司的股东(公司)的营业执照原件扫描件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="corporateCompanyMembers.length != 0">
          <p class="messageTitle">
            {{ $t("enroll.upload.fundManagerBusinessTitle") }}
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.comprehensiveBusinessTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="corporateCompanyMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.nameOrCompany')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.shareholderOrCompany')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyMemberList.${getRealIndex(scope.row, 'companyMemberList')}.businessLicenseUrls`"
                    :ref="`companyMemberList.${getRealIndex(scope.row, 'companyMemberList')}.businessLicenseUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.businessLicenseUrls"
                      :action="`${ossUploadUrl}/fileUpload/businessLicenseUrls/upload`"
                      :button-text="$t('enroll.upload.businessUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 公司的Business Profile (营业执照) & 章程 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.comprehensiveProfileAndFundArticles") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.comprehensiveProfileAndArticlesFundSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferBusinessProfileAndArticleUrls"
                  ref="transferBusinessProfileAndArticleUrls"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferBusinessProfileAndArticleUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferBusinessProfileAndArticleUrls/upload`"
                    :button-text="$t('enroll.upload.comprehensiveProfileUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 公司的股权架构图 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.comprehensiveFundStructure") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.comprehensiveStructureSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferShareholdingStructureUrls"
                  ref="transferShareholdingStructureUrls"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferShareholdingStructureUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferShareholdingStructureUrls/upload`"
                    :button-text="$t('enroll.upload.comprehensiveStructureFundUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 公司的最新的年度财务报告(若适用) -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.comprehensiveFundFinancial") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferAnnualFinancialReportUrls"
                  ref="transferAnnualFinancialReportUrls"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferAnnualFinancialReportUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferAnnualFinancialReportUrls/upload`"
                    :button-text="$t('enroll.upload.comprehensiveFinancialUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 公司的注册地址证明原件扫描件 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.comprehensiveFundAddress") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.comprehensiveAddressSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferRegisteredOfficeAddressCertificateUrls"
                  ref="transferRegisteredOfficeAddressCertificateUrls"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferRegisteredOfficeAddressCertificateUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferRegisteredOfficeAddressCertificateUrls/upload`"
                    :button-text="$t('enroll.upload.comprehensiveAddressUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 公司的现任公司秘书的信息 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.comprehensiveFundSecretary") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.comprehensiveSecretaryFundSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferSecretaryParticularsUrls"
                  ref="transferSecretaryParticularsUrls"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferSecretaryParticularsUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferSecretaryParticularsUrls/upload`"
                    :button-text="$t('enroll.upload.comprehensiveSecretaryFundUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 公司的财务主管和税务主管的信息 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.comprehensiveFundFinance") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.comprehensiveFinanceFundSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item prop="financeTaxUrls" ref="financeTaxUrls" :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }">
                  <table-upload
                    v-model="scope.row.financeTaxUrls"
                    :action="`${ossUploadUrl}/fileUpload/financeTaxUrls/upload`"
                    :button-text="$t('enroll.upload.comprehensiveFinanceFundUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 最终受益人的身份证件/营业执照和地址证明 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="dataForm.questionnaire?.ultimateBeneficiaryInfo?.length">
          <p class="messageTitle">
            {{ $t("enroll.upload.ultimateBeneficialId") }}
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.ultimateBeneficialIdTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="dataForm.questionnaire.ultimateBeneficiaryInfo">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.intitle.type')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("memberTypeList", scope.row.memberType) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`questionnaire.ultimateBeneficiaryInfo.${scope.$index}.ultimateBeneficiaryBusinessLicenseUrls`"
                    :ref="`questionnaire.ultimateBeneficiaryInfo.${scope.$index}.ultimateBeneficiaryBusinessLicenseUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.ultimateBeneficiaryBusinessLicenseUrls"
                      :action="`${ossUploadUrl}/fileUpload/ultimateBeneficiaryBusinessLicenseUrls/upload`"
                      :button-text="$t('enroll.upload.ultimateBeneficialIdUpload')"
                      :accept="'image/jpg,image/jpeg,image/png,application/pdf,application/msword,text/plain'"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 本次公司设立申请的授权文件扫描件(若申请人不是新设公司的董事或直接/间接股东) -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="dataForm.applicantPosition == 'INDIRECT_SHAREHOLDER' || dataForm.applicantPosition == 'OTHER'">
          <p class="messageTitle">
            {{ $t("enroll.upload.notApplicantTitle") }}
          </p>
          <div class="pt20">
            <el-table border :data="[dataForm]">
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <div v-if="dataForm.applicantPosition == 'OTHER'">
                    <el-form-item
                      prop="authorizationUrls"
                      ref="authorizationUrls"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.authorizationUrls"
                        :action="`${ossUploadUrl}/fileUpload/authorizationUrls/upload`"
                        :button-text="$t('enroll.upload.authorizationFileUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>
                  <!-- 申请人的身份证件原件扫描件 -->
                  <el-form-item
                    prop="applicantIdentificationUrls"
                    ref="applicantIdentificationUrls"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.applicantIdentificationUrls"
                      :action="`${ossUploadUrl}/fileUpload/applicantIdentificationUrls/upload`"
                      :button-text="$t('enroll.upload.applicantIdentityUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 上传与促销编号相关的支持文件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="dataForm.promotionCode">
          <p class="messageTitle">
            {{ $t("enroll.upload.promotionCertified") }}
          </p>
          <div class="pt20">
            <el-table border :data="[dataForm]">
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    prop="promotionCertifiedUrls"
                    ref="promotionCertifiedUrls"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.promotionCertifiedUrls"
                      :action="`${ossUploadUrl}/fileUpload/promotionCertifiedUrls/upload`"
                      :button-text="$t('enroll.upload.promotionCertifiedUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import request from "@/utils/request";
import { validateLocation } from "@/utils/common";
import { mapGetters } from "vuex";
export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ossUploadUrl: request.defaults.baseURL,
      dataForm: {},
    };
  },
  computed: {
    ...mapGetters("constant", ["getGlobalLabel"]),
    // 基金管理公司的董事|股东(个人)
    individualCompanyMembers() {
      return (this.dataForm.companyMemberList || []).filter(m => m.memberType === "INDIVIDUAL" && m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    // 基金管理公司的股东(公司)
    corporateCompanyMembers() {
      return (this.dataForm.companyMemberList || []).filter(m => m.memberType === "CORPORATE" && m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    // 基金管理公司的所有活跃成员
    allActiveCompanyMembers() {
      return (this.dataForm.companyMemberList || []).filter(m => m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    // 基金的董事|股东(个人)
    individualFundMembers() {
      return (this.dataForm.companyFundMemberList || []).filter(m => m.memberType === "INDIVIDUAL" && m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    // 基金的股东(公司)
    corporateFundMembers() {
      return (this.dataForm.companyFundMemberList || []).filter(m => m.memberType === "CORPORATE" && m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    // 基金的所有活跃成员
    allActiveFundMembers() {
      return (this.dataForm.companyFundMemberList || []).filter(m => m.positionHeld !== "NOMINEE_DIRECTOR");
    },
  },
  methods: {
    // 获取成员在原始列表中的真实索引（用于表单验证 prop）
    getRealIndex(row, list) {
      return (this.dataForm[list] || []).indexOf(row);
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      const params = JSON.parse(JSON.stringify(this.dataForm));

      if (params.companyFundMemberList) {
        params.companyFundMemberList.forEach(m => {
          m.isOfFund = 1;
        });
      }
      if (params.applicantPosition !== "OTHER") {
        params.authorizationUrls = [];
      }
      if (params.applicantPosition !== "INDIRECT_SHAREHOLDER" && params.applicantPosition !== "OTHER") {
        params.applicantIdentificationUrls = [];
      }

      return params;
    },
    // 触发必填校验(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
    // 页面初始化数据整理
    pageInit(data) {
      this.dataForm = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.messageTitle {
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
}
</style>
